import { WxSdk } from './WxSdk'
export class WxShare extends WxSdk {
  constructor() {
    super()
    this.menuList = [
      'menuItem:copyUrl',
      'menuItem:favorite',
      'menuItem:originPage',
      'menuItem:readMode',
      'menuItem:openWithQQBrowser',
      'menuItem:openWithSafari',
      'menuItem:share:email',
      'menuItem:editTag',
      'menuItem:share:qq',
      'menuItem:share:weiboApp',
      'menuItem:share:facebook',
      'menuItem:share:QZone',
      'menuItem:share:timeline',
      'menuItem:share:appMessage'
    ]
    this.url = '' // 历史url
  }

  /**
   * 分享初始化：1. 向服务端获取签名 2. 通过config接口注入权限验证配置
   * @param {*} url 需要sdk的页面
   * @param {*} cityId
   * @returns Promise
   */

  init({ url, cityId }) {
    if (!url || !cityId) {
      console.error('share init: 参数错误')
      return Promise.reject()
    }
    return this.getWxSign({ url, cityId }).then(
      ({ appId, timeStamp, nonceStr, signature }) => {
        this.wxConfig({
          appId,
          timeStamp,
          nonceStr,
          signature,
          jsApiList: [
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'hideMenuItems',
            'showMenuItems'
          ]
        })
      }
    )
  }

  /**
   * wx ready 回调函数
   * @param {function} callback
   */
  installReady(callback) {
    this.installReadyCallback(callback)
  }

  /**
   * wx error 回调函数
   */
  installError() {
    this.installErrorCallback(err => {
      console.error('installError err:', err)
    })
  }

  /**
   * 禁用某个或者全部微信按钮
   * @param {string | undefined} shareType
   */
  hideWxMenus(menuItem) {
    let menuList = menuItem ? [menuItem] : this.menuList
    this.checkJsApi(['hideMenuItems']).then(wx => {
      wx.hideMenuItems({ menuList })
    })
  }

  /**
   * 展示某个或者全部微信按钮
   * @param {string | undefined} shareType
   */
  showWxMenus(menuItem) {
    let menuList = menuItem ? [menuItem] : this.menuList
    this.checkJsApi(['showMenuItems']).then(wx => {
      wx.showMenuItems({ menuList })
    })
  }
}
